import { useMemo, useRef, useState } from "react";
import RadarBeatSignal from "components/field/RadarBeatSignal";
import RadarSpectrum from "components/field/RadarSpectrum";
import { useRadarCaptureDetail } from "hooks/useRadarData";
import { useLabCaptures } from "hooks/useRadarLab";
import { formatMm, sgtTime } from "utils/radarDiagnostics";
import { captureKinds } from "utils/radarLab";

// The radar captures taken during a lab run (the newest 100): pick one to see
// its spectrum and beat signal with the Radar analysis page's own views.
export default function LabCaptures({ runId, active, refresh }) {
  const captures = useLabCaptures(runId, active, refresh);
  const newestFirst = useMemo(() => [...captures.captures].reverse(), [captures.captures]);
  const [picked, setPicked] = useState(null);
  const shown = newestFirst.find((c) => c.id === picked) || newestFirst[0] || null;
  const cache = useRef(new Map());
  const detail = useRadarCaptureDetail(shown?.has_adc ? shown.id : null, 0, cache);
  const hasSpectrum = Array.isArray(shown?.db) && shown.db.some((v) => v !== null);
  return (
    <div>
      {captures.error && (
        <div className="field-alert" role="alert">
          {captures.error}
        </div>
      )}
      {!newestFirst.length ? (
        <p className="field-caption">
          No radar captures in this lab run yet. They arrive with the node's stream while it runs.
        </p>
      ) : (
        <div className="field-lab-captures">
          <ul className="field-lab-capture-list" aria-label="Captures in this lab run">
            {newestFirst.map((c) => (
              <li key={c.id}>
                <button
                  type="button"
                  aria-pressed={shown?.id === c.id}
                  onClick={() => setPicked(c.id)}
                >
                  {sgtTime(c.t)} · {captureKinds(c)}
                  {c.air_mm !== null && c.air_mm !== undefined ? ` · ${formatMm(c.air_mm)}` : ""}
                </button>
              </li>
            ))}
          </ul>
          <div style={{ minWidth: 0 }}>
            {shown && hasSpectrum && (
              <RadarSpectrum capture={shown} range="near" unit={captures.unit} />
            )}
            {shown?.has_adc && (
              <RadarBeatSignal capture={shown} detail={detail} />
            )}
            {shown && !hasSpectrum && !shown.has_adc && (
              <p className="field-caption">This capture carries neither a spectrum nor a beat signal.</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
